"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedEntryDetailsLayout = exports.FeedEntryDetailsLayoutDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var format_date_string_1 = require("../../utils/format-date-string");
var use_lang_1 = require("../../hooks/use-lang");
var use_entities_1 = require("../../hooks/use-entities");
var action_link_1 = require("../elements/action-link");
var grid_1 = require("../elements/grid");
var main_aside_1 = require("../elements/main-aside");
var link_1 = require("../elements/link");
var entity_link_1 = require("./entity-link");
var entity_list_1 = require("./entity-list");
var entity_value_1 = require("./entity-value");
var content_section_1 = require("../elements/content-section");
var content_node_1 = require("./content-node");
var entity_multi_value_list_1 = require("./entity-multi-value-list");
var entity_list_section_1 = require("./entity-list-section");
var entity_link_value_1 = require("./entity-link-value");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var entity_details_linked_grid_1 = require("./entity-details-linked-grid");
exports.FeedEntryDetailsLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ActionLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-size: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.FONT_SIZE(14), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(15))
});
var EntityLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    ", ";\n  "], ["\n    padding: ", " ", " ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.UNIT(5), theme_1.theme.H_DOT_BG_END())
});
var SummaryStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MultiValueListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var OfferingTypeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    width: 100%;\n    margin-top:", ";\n  "], ["\n    width: 100%;\n    margin-top:", ";\n  "])), theme_1.theme.UNIT(4))
});
var RelatedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var PlacesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    margin-top: -", "px;\n  "], ["\n    margin-top: -", "px;\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components --------->
var My = {
  Container: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Summary: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), SummaryStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Main: styled_components_1.default.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  Related: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), RelatedStyles),
  List: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  ActionLink: (0, styled_components_1.default)(action_link_1.ActionLink)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), ActionLinkStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  OfferingType: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), OfferingTypeStyles),
  MultiValueList: (0, styled_components_1.default)(entity_multi_value_list_1.EntityMultiValueList)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), MultiValueListStyles),
  EntityLink: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), EntityLinkStyles),
  Grid: (0, styled_components_1.default)(entity_details_linked_grid_1.EntityDetailsLinkedGrid)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Places: (0, styled_components_1.default)(grid_1.Grid)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), PlacesStyles)
};
var FeedEntryDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter,
    related = props.related,
    banner = props.banner;
  var entities = (0, use_entities_1.useEntities)();
  var t = (0, use_lang_1.useLang)();
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var _a = entity.people,
    people = _a === void 0 ? [] : _a,
    summary = entity.summary,
    websiteName = entity.websiteName,
    websiteUrl = entity.websiteUrl,
    offeringType = entity.offeringType,
    _b = entity.locations,
    locations = _b === void 0 ? [] : _b,
    _c = entity.keyIssues,
    keyIssues = _c === void 0 ? [] : _c,
    _d = entity.economies,
    economies = _d === void 0 ? [] : _d,
    _e = entity.organisations,
    organisations = _e === void 0 ? [] : _e,
    _f = entity.challenges,
    challenges = _f === void 0 ? [] : _f,
    _g = entity.types,
    types = _g === void 0 ? [] : _g,
    url = entity.url;
  var hasChallenges = entities.Challenge && !!challenges.length;
  var hasOfferingType = entities.OfferingType && offeringType;
  var hasKeyIssues = entities.KeyIssue && !!keyIssues.length;
  var hasPeople = !!people.length;
  var hasOrganisations = !!organisations.length;
  var hasRelated = related || hasOfferingType || hasChallenges || hasKeyIssues || hasPeople || hasOrganisations;
  var hasPlaces = !!locations.length || !!economies.length;
  // synthesise a list of related entities so they may be rendered as `EntityValue`
  var author = entity.author && {
    id: entity.author,
    __typename: 'Author',
    name: entity.author
  };
  var link = url && {
    id: url,
    __typename: 'Link',
    name: 'Read this article'
  };
  var publisher = websiteName && websiteUrl && {
    id: websiteName,
    __typename: 'Site',
    name: websiteName
  };
  var published = entity.published && {
    id: 'published',
    __typename: 'Event',
    name: (0, format_date_string_1.formatDateString)(entity.published, 'Do MMM YYYY', 'YYYY-MM-DD')
  };
  return React.createElement(My.Container, {
    className: className
  }, banner, React.createElement(My.MainAside, {
    main: React.createElement(My.Main, null, mainHeader, React.createElement(My.Section, {
      title: "About:"
    }, React.createElement(My.Summary, {
      entity: summary
    }), React.createElement(My.Grid, {
      entity: entity,
      columns: 3,
      spacing: 3,
      items: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([link && React.createElement(My.Link, {
        to: url
      }, React.createElement(My.Value, {
        entity: link
      })), publisher && React.createElement(My.Link, {
        to: websiteUrl
      }, React.createElement(My.Value, {
        label: "Website",
        entity: publisher
      })), author && React.createElement(My.Value, {
        entity: author
      }), published && React.createElement(My.Value, {
        label: "Published",
        entity: published
      })], __read(locations.map(function (entity) {
        return React.createElement(My.LinkValue, {
          entity: entity
        });
      })), false), __read(economies.map(function (entity) {
        return React.createElement(My.LinkValue, {
          entity: entity
        });
      })), false), __read(people.map(function (entity) {
        return React.createElement(My.LinkValue, {
          entity: entity
        });
      })), false), __read(types.map(function (entity) {
        return React.createElement(My.Value, {
          entity: entity
        });
      })), false), __read(organisations.map(function (entity) {
        return React.createElement(My.LinkValue, {
          entity: entity
        });
      })), false), __read(hasChallenges ? challenges.map(function (entity) {
        return React.createElement(My.LinkValue, {
          entity: entity
        });
      }) : []), false), __read(hasKeyIssues ? keyIssues.map(function (entity) {
        return React.createElement(My.LinkValue, {
          entity: entity
        });
      }) : []), false), [hasOfferingType && React.createElement(My.OfferingType, {
        entity: offeringType
      })], false)
    })), mainFooter)
  }));
};
exports.FeedEntryDetailsLayout = FeedEntryDetailsLayout;
exports.FeedEntryDetailsLayout.defaultProps = exports.FeedEntryDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35;